/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';
const Google = () => {
  return (
    <div>
          <iframe className='google' src="https://maps.google.com/maps?q=amazon%20headquarters&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=&amp;output=embed"  frameborder="0" scrolling="no" alt='' ></iframe>
    </div>
  )
}

export default Google